import { createRouter, createWebHistory } from "vue-router";
import store from '../store/index'
import Dashboard from "../views/Dashboard.vue";
import RFQ from "../views/RFQ.vue";
import RFQDetail from "../views/RFQDetail.vue";
import PO from "../views/PO.vue";
import PODetail from "../views/PODetail.vue";
import VendorBill from "../views/VendorBill.vue";
import VendorBillDetail from "../views/VendorBillDetail.vue";
import Tender from "../views/Tender.vue";
import TenderDetail from "../views/TenderDetail.vue";
import Bidding from "../views/Bidding.vue";
import BiddingDetail from "../views/BiddingDetail.vue";
import Profile from "../views/Profile.vue";
// import Signup from "../views/Signup.vue";
import Signin from "../views/Signin.vue";
// import ForgotPassword from "../views/ForgotPassword.vue";
import NotFound from "../views/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  { path: '/:notFound', component: NotFound },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Dashboard,
    meta: { requireAuth: true },
  },
  {
    path: "/rfq",
    name: "Request For Quotation",
    component: RFQ,
    meta: { requireAuth: true },
  },
  {
    path: "/rfq/:id",
    name: "Request For Quotation Detail",
    component: RFQDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/purchase-order",
    name: "Purchase Order",
    component: PO,
    meta: { requireAuth: true },
  },
  {
    path: "/purchase-order/:id",
    name: "Purchase Order Detail",
    component: PODetail,
    meta: { requireAuth: true },
  },
  {
    path: "/vendor-bill",
    name: "Vendor Bills",
    component: VendorBill,
    meta: { requireAuth: true },
  },
  {
    path: "/vendor-bill/:id",
    name: "Vendor Bills Detail",
    component: VendorBillDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/tender",
    name: "Tender",
    component: Tender,
    meta: { requireAuth: true },
  },
  {
    path: "/tender/:id",
    name: "Tender Detail",
    component: TenderDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/request-for-proposal",
    name: "Request For Proposal",
    component: Bidding,
    meta: { requireAuth: true },
  },
  {
    path: "/request-for-proposal/:id",
    name: "Request For Proposal Detail",
    component: BiddingDetail,
    meta: { requireAuth: true },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: { requireAuth: true },
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  }
  // {
  //   path: "/forgot-password",
  //   name: "Forgot Password",
  //   component: ForgotPassword,
  // }
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.checkLogin)) {
    if (!store.getters['isLogin']) {
      next()
      return
    }
    // jika belum login atau tidak ada token tersimpan
    next('/')
    return
  }
  if (to.matched.some(record => record.meta.requireAuth)) {
    if (localStorage.getItem('isLogin') || store.getters['isLogin']) {
      next()
      return
    }
    // jika belum login atau tidak ada token tersimpan
    next('/signin')
    return
  }
  next()
})

export default router;
